import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="delivery-tip"
export default class extends Controller {
  select(event) {
    const option = event.currentTarget
    const amount = parseInt(option.dataset.amount)
    const baseTotal = parseInt(document.getElementById("tip_total").dataset.baseTotal)

    // Visual: marcar seleccionado
    document.querySelectorAll(".delivery-tip-option").forEach(el => el.classList.remove("active"))
    option.classList.add("active")

    // Actualizar valores
    document.getElementById("tip_input").value = amount
    document.getElementById("tip_amount").textContent = `$${amount.toLocaleString("es-CL")}`
    document.getElementById("tip_total").textContent = `$${(baseTotal + amount).toLocaleString("es-CL")}`

    // Ocultar input custom si se selecciona una opción predefinida
    document.getElementById("custom_tip").style.display = "none"
  }

  showCustom(event) {
    document.querySelectorAll(".delivery-tip-option").forEach(el => el.classList.remove("active"))
    event.currentTarget.classList.add("active")
    document.getElementById("custom_tip").style.display = "block"
    document.getElementById("custom_tip_input").focus()
  }

  updateCustom(event) {
    const amount = parseInt(event.currentTarget.value) || 0
    const baseTotal = parseInt(document.getElementById("tip_total").dataset.baseTotal)

    document.getElementById("tip_input").value = amount
    document.getElementById("tip_amount").textContent = `$${amount.toLocaleString("es-CL")}`
    document.getElementById("tip_total").textContent = `$${(baseTotal + amount).toLocaleString("es-CL")}`
  }
}